// extracted by mini-css-extract-plugin
export default {"calendarDay":"CalendarDay_calendarDay__CGlXj","shineLoop":"CalendarDay_shineLoop__Pg0dK"};